import runReference from "../../../references/run-reference";
import getReference from "../on-step-status/get-reference";

/**
 *
 * @param {Boolean} enter
 * @param {Map<"enter-active" | "leave-active" | "hook", Boolean | String>} status
 * @param {Boolean} isStep
 * @param {TimelineMapProps | StepProps | PropertyValueProps} property
 */
const runOffsetHook = (enter, status, isStep, property) => {
  /** Hook string @example `on|30%` */
  const hook = /** @type {"offset-hooks"} */ (status.get("hook"));

  const reference = isStep ? getReference(property, hook) : property.get(hook);

  runReference(enter, reference);
};

export default runOffsetHook;
